import { render } from "./ListeMagasin.vue?vue&type=template&id=33ae7768&ts=true"
import script from "./ListeMagasin.vue?vue&type=script&lang=ts"
export * from "./ListeMagasin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__